module.exports = __webpack_public_path__ + "static/media/M&V_logo2.e1d1c9db.jpg";